import { render, staticRenderFns } from "./_sso-configuration.vue?vue&type=template&id=505f531c&scoped=true"
import script from "./_sso-configuration.vue?vue&type=script&lang=js"
export * from "./_sso-configuration.vue?vue&type=script&lang=js"
import style0 from "./_sso-configuration.vue?vue&type=style&index=0&id=505f531c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505f531c",
  null
  
)

export default component.exports